export function getInitials(name) {
    if (!name) return '?'
    const parts = name.split(' ')
    return parts.length >= 2
        ? (parts[0][0] + parts[1][0]).toUpperCase()
        : name.substring(0, 2).toUpperCase()
}